module.exports = __webpack_public_path__ + "img/3.d8cd8cb5.jpg";